export default "__VITE_ASSET__C1J7wHx9__"